"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable jsx-a11y/role-supports-aria-props,jsx-a11y/no-noninteractive-element-interactions */
const react_1 = require("react");
const classnames_1 = __importDefault(require("classnames"));
const useMergeRefs_1 = __importDefault(require("../../hooks/useMergeRefs"));
const sizes_1 = require("../../constants/sizes");
const KeyCodes_1 = require("../../constants/KeyCodes");
const function_utils_1 = require("../../utils/function-utils");
require("./ListItem.scss");
const BEM_BASE_CLASS = "list-item";
function BEMHelper(state) {
    return `${BEM_BASE_CLASS}--${state}`;
}
const ListItem = (0, react_1.forwardRef)(({ className, id, onClick = function_utils_1.NOOP, onHover = function_utils_1.NOOP, selected, disabled = false, size = sizes_1.SIZES.SMALL, tabIndex = 0, children }, ref) => {
    const componentRef = (0, react_1.useRef)(null);
    const mergedRef = (0, useMergeRefs_1.default)({ refs: [ref, componentRef] });
    const componentOnClick = (0, react_1.useCallback)((event) => {
        if (disabled)
            return;
        onClick(event, id);
    }, [disabled, onClick, id]);
    const onKeyDown = (0, react_1.useCallback)((event) => {
        if (disabled)
            return;
        const KEYS = [KeyCodes_1.keyCodes.ENTER, KeyCodes_1.keyCodes.SPACE];
        if (KEYS.includes(event.key)) {
            onClick(event, id);
        }
    }, [disabled, onClick, id]);
    const componentOnHover = (0, react_1.useCallback)((event) => {
        if (disabled)
            return;
        onHover(event, id);
    }, [disabled, onHover, id]);
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ ref: mergedRef, className: (0, classnames_1.default)("list-item", className, BEMHelper(size.toString()), {
            [BEMHelper("selected")]: selected && !disabled,
            [BEMHelper("disabled")]: disabled
        }), id: id, "aria-disabled": disabled, onClick: componentOnClick, onKeyDown: onKeyDown, onMouseEnter: componentOnHover, onFocus: componentOnHover, role: "listitem", tabIndex: tabIndex }, { children: children })));
});
Object.assign(ListItem, {
    sizes: sizes_1.SIZES,
    // Used by VirtualizedListItems
    displayName: "ListItem"
});
exports.default = ListItem;
